<template>
  <!-- 我参与的项目 -->
  <div class='myJoin'>
    <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill="false" ref="loadmore">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">   
      <ul class='myJoin_list pjt_list'>
        <li v-for="(pjtList, index) in pjtLists" :key="index" @click="toDetail(pjtList)">
          <div class="bgImg" :class="{'zhaomu':pjtList.status==4,'close':pjtList.status==2,'close1':pjtList.status==3,'close2':pjtList.status==5,'jinxing':pjtList.status==7,'over':pjtList.status==8,'hezuo':pjtList.status==6,'pingjia':pjtList.status==9,'shenhe':pjtList.status==1}"></div>
          <h4>{{pjtList.title}}</h4>
          <span class="pjt_type">{{pjtList.typeName}}</span>
          <div class="path">
            <div class="money">
              <span>项目经费</span>
              <p>{{pjtList.charge}}</p>
            </div>
            <div class="start_time">
              <span>开始时间</span>
              <p>{{pjtList.startDate | formatDate}}</p>
            </div>
            <div class="over_time">
              <span>结束时间</span>
              <p>{{pjtList.endDate | formatDate}}</p>
            </div>
          </div>
          <div class="skills">
            <span v-for='(skillsList,index) in pjtList.skillsList' :key="index">{{skillsList}}</span>
          </div>
          <div class="release_time"><icon name="clock-o"></icon>{{pjtList.time}}</div>
          <div class='describe'>
            <p>需求描述:</p>
            <span style="-webkit-box-orient: vertical;">{{pjtList.description}}</span>
          </div>
          <div v-if="false" class='doing'>
            <img src="../assets/img/qqq.jpg">
            <span class="name"><span>真准配</span>发布</span>
            <button type="button" class="sendBtn">发送消息</button>
          </div>
          <div class="people">
            <span>已推荐<span>{{pjtList.countRecommender}}</span>人</span>
            <span><i class="people_icon"></i>已申请<span>{{pjtList.countOffer}}</span>人</span>
            <span><i class="people_icon"></i>已浏览<span>{{pjtList.countVisit}}</span>人</span>
          </div>
        </li>
      </ul>
    </van-list>
    </mt-loadmore>
  </div>
</template>

<script>
import {formatDate} from '../assets/js/date.js'
import { Indicator } from 'mint-ui'
export default {
  name: 'home',
  data () {
    return {
      pjtLists: '',
      searchCondition: {
        pageNo: 0,
        pageSize: '10'
      },
      allLoaded: false,
      scrollMode: 'auto',
      msg: '欢迎来到云智图App',
      loading: false,
      finished: false,
    }
  },
  mounted () {
    this.loadPageList()
  },
  methods: {
    onLoad: function () {
      let _this = this
      this.searchCondition.pageNo = this.searchCondition.pageNo + 1
      setTimeout(() => {
        this.axios.get('url/work/project/weiXinMyJoinProjectLists?accountId=' + _this.STATE.state.loginId + '&rows=10&page=' + _this.searchCondition.pageNo)
        .then(function (res) {
          if(res){
            // 加载状态结束
            _this.loading = false;
            if(_this.searchCondition.pageNo==1){
              _this.pjtLists = res.data
            }else{
              _this.pjtLists = _this.pjtLists.concat(res.data)
            }
            if (res.data.length <10) {
                _this.finished = true;
            }
          }
        }).catch(function (response) {
        })
      }, 500)
    },
    loadTop: function () {
      this.loadPageList()
      this.$refs.loadmore.onTopLoaded()
    },
    loadBottom: function () {
      this.more()
      this.$refs.loadmore.onBottomLoaded()
    },
    loadPageList: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.axios.get('url/work/project/weiXinMyJoinProjectLists?accountId=' + this.STATE.state.loginId + '&rows=10&page=1')
      .then(function (res) {
        Indicator.close()
        _this.pjtLists = res.data
        if (res.data.length < 10) {
          _this.finished = true
        }else{
          _this.finished = false;
        }
        console.log(_this.pjtLists)
      }).catch(function (response) {
        Indicator.close()
      })
    },
    more: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.searchCondition.pageNo = parseInt(this.searchCondition.pageNo) + 1
      this.axios.get('url/work/project/weiXinMyJoinProjectLists?accountId=' + this.STATE.state.loginId + '&rows=10&page=' + this.searchCondition.pageNo)
      .then(function (res) {
        Indicator.close()
        _this.pjtLists = _this.pjtLists.concat(res.data)
        if (res.data.length !== 10) {
          _this.allLoaded = true
        }
      }).catch(function (response) {
        Indicator.close()
      })
    },
    toDetail (project) {
      this.STATE.state.chooseMyJob = 'myJoin'
      this.$router.push({name: 'myProjectDetail', params: { project: project, projectId: project.id }})
    }
  },
  filters: {
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd')
    }
  }
}
</script>

<style scoped>
.myJoin{
  background-color:#f0eff5;
}
.myJoin_list li{
  background-color:#fff;
  margin-bottom:5px;
  border-top:1px solid #ccc;
  border-bottom:1px solid #ccc;
  padding:10px 15px 0;
}
li h4{
  font-size:14px;
  color:#727272;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
li .pjt_type{
  display:inline-block;
  font-size:12px;
  background-color:#e9fafd;
  color:#108ee9;
  padding:3px 5px;
  -webkit-border-radiu:12px;
  -moz-border-radiu:12px;
  border-radius:12px;
  margin:5px 0;
}
li .path{
  overflow:hidden;
}
li .path div{
  float:left;
  margin-right:15px;
}
.path div span{
  color:#727272;
  font-size:12px;
}
.path div p{
  font-size:18px;
}
li .skills{
  max-height:60px;
  overflow:hidden;
}
li .skills span{
  display:inline-block;
  font-size:12px;
  padding:3px 5px;
  background-color:#f2f2f2;
  color:#a6a6a6;
  -webkit-border-radiu:5px;
  -moz-border-radiu:5px;
  border-radius:5px;
  margin:3px 10px;
}
.release_time{
  font-size:12px;
  color:#727272;
  margin-top:5px;
}
.release_time .fa-icon{
  color:#cecece;
  height:10px;
}
.describe{
  margin-top:10px;
}
.describe p{
  font-size:14px;
  color:#727272;
  float:left;
  margin-right:10px;
}
.describe span{
  font-size:14px;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow:hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
li .doing{
    margin:13px -15px 0;
    height:40px;
    border-top:1px solid #ccc;
    border-bottom:1px solid #ccc;
    background-color:#f5f5f5;
    padding:0 15px;
  }
li .doing img{
  width:30px;
  height:30px;
  -webkit-border-radiu:50%;
  -moz-border-radiu:50%;
  border-radius:50%;
  margin-top:5px;
  vertical-align:middle;
}
li .doing .name{
  font-size:12px;
  margin-left:5px;
  vertical-align:middle;
  display:inline-block;
  margin-top:5px;
}
li .doing .name span{
  color:#8e8e8e;
  margin-right:12px;
}
li .doing .sendBtn{
  color:#fff;
  font-size:12px;
  background-color:#108ee9;
  /* padding:5px 15px; */
  float:right;
  border:none;
  -webkit-border-radiu:5px;
  -moz-border-radiu:5px;
  border-radius:5px;
  /* margin-top:7px; */
}
li .people{
  margin: 0 -15px;
  line-height:45px;
  background-color:#f5f5f5;
  padding:0 15px;
}
li .people span{
  font-size:12px;
  color:#727272;
  margin-right:20px;
}
li .people span span{
  margin:0 5px;
}
.pjt_list li .bgImg{
  width:44px;
  height:44px;
  float:right;
  margin-right:-15px;
  margin-top:-10px;
  background-size:100% 100%;
}
.pjt_list li .zhaomu{
    background-image:url('../assets/img/main_app/state-4.png');
  }
  .pjt_list li .close{
    background-image:url('../assets/img/main_app/state-5.png');
  }
  .pjt_list li .close1{
    background-image:url('../assets/img/main_app/state-5.png');
  }
  .pjt_list li .close2{
    background-image:url('../assets/img/main_app/state-5.png');
  }
  .pjt_list li .jinxing{
    background-image:url('../assets/img/main_app/state-7.png');
  }
  .pjt_list li .over{
    background-image:url('../assets/img/main_app/state-8.png');
  }
  .pjt_list li .hezuo{
    background-image:url('../assets/img/main_app/state-6.png');
  }
  .pjt_list li .pingjia{
    background-image:url('../assets/img/main_app/state-8.png');
  }
  .pjt_list li .shenhe{
    background-image:url('../assets/img/main_app/state-10.png');
  }
.mint-loadmore{
  margin-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// myJoin_pjt.vue?3cc8e0d5